// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const tva: CountryValidator<"FR"> = createValidator(
  "fr.tva",
  78,
);

export default tva;
export const compact = tva.compact;
export const format = tva.format;
export const validate = tva.validate;
export const generate = (): string =>
  tva.generate?.() ??
  (() => {
    throw new Error(
      "Validator fr.tva cannot generate values",
    );
  })();
